import { createFileRoute } from '@tanstack/react-router'

import { LineItemDetailPage } from '@/pages/line-items/[id]/LineItemDetailPage'

export const Route = createFileRoute('/_authenticated/_dashboard/line-items/$id/')({
  component: LineItemDetailPage,
})
